import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { API_URLS } from '../constants/apiUrl';
import { patch } from '../api/api';
import { useLoading } from '../context/LoadingContext';
import { useUser } from '../context/UserContext';
import { showToast } from '../components/utils/toast';
import { IUpdateCurrentUser, IUpdateCurrentUserFields, IUserDetails } from '../interface/user';

export const useUpdateCurrentUser = (): UseMutationResult<
  IUserDetails,
  AxiosError<{ message?: string; type?: string }>,
  IUpdateCurrentUserFields
> => {
  const queryClient = useQueryClient();
  const { updateUserDetails } = useUser();
  const { setIsLoading } = useLoading();

  const updateCurrentUser = async (fields: IUpdateCurrentUserFields): Promise<IUserDetails> => {
    const currentUser = queryClient.getQueryData<IUserDetails>(['user']);
    const payload: IUpdateCurrentUser = { ...fields, version: currentUser?.version ?? '' };
    return patch(API_URLS.UPDATE_CURRENT_USER, payload);
  };

  return useMutation({
    mutationFn: updateCurrentUser,
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(['user'], data);
      updateUserDetails(data);
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
